<template>
  <LayoutPage>
    <template #aside>
      <CompositeAsideCard title="Production photovoltaïque" subtitle="Production du mois précédent"
        :key-info='store.getSolar.energy_produced.toLocaleString("fr-FR")' key-info-label="kWh d'électricité produits"
        :tip-description="['Plus l’ensoleillement est important plus les panneaux peuvent convertir la lumière solaire en électricité']"
        tip-green-background>
        <template #key-info-icon>
          <IconPhotovoltaicElectricityWhite />
        </template>
        <template #tip-icon>
          <IconSunGreen />
        </template>
      </CompositeAsideCard>
    </template>
    <template #content>
      <CompositeChartSection class="photovoltaic-production-chart" title="Production photovoltaïque"
        :chips="[{ title: new Date().getFullYear().toString(), backgroundColor: '#2271b9' }, { title: (new Date().getFullYear() - 1).toString(), backgroundColor: '#7c888f' }]">
        <ChartBars v-if="isMounted"
          :datasets="[{ backgroundColor: '#0072ce', data: store.solar.energy_year_current }, { backgroundColor: '#737373', data: store.solar.energy_year_last }]"
          :stepsize="1000" yAxisLegend="Production en kWh" />
      </CompositeChartSection>
      <CompositeDidYouKnowCard class="photovoltaic-production-did-you-know" title="Bon à savoir"
        description="Au dernier étage, 150 m² de panneaux sont installées sur un système d’étanchéité Soprasolar® Fix Evo Tilt."
        vertical :img="LGCSolar" />
    </template>
  </LayoutPage>
</template>

<script lang="ts" setup>
import ChartBars from '@/components/common/charts/ChartBars.vue'
import CompositeAsideCard from '@/components/composite/CompositeAside.vue'
import CompositeChartSection from '@/components/composite/CompositeChartSection.vue'
import CompositeDidYouKnowCard from '@/components/composite/CompositeDidYouKnowCard.vue'
import LayoutPage from '@/components/layout/LayoutPage.vue'
import IconPhotovoltaicElectricityWhite from '@/components/icons/IconPhotovoltaicElectricityWhite.vue'
import IconSunGreen from '@/components/icons/IconSunGreen.vue'
import { useDataStore } from '@/stores/store_data'
import { onMounted, ref } from 'vue'
import LGCSolar from '@/assets/images/did-you-know.jpg'

const store = useDataStore()
const isMounted = ref<boolean>(false)

onMounted(() => {
  store.fetchLGCData().then(() =>
    isMounted.value = true
  )
})
</script>

<style scoped lang="scss">
.photovoltaic-production {
  &-chart {
    width: 65%;
    height: 100%;
  }

  &-did-you-know {
    width: 35%;
    height: 100%;
    z-index: 10;
  }
}
</style>
